import React from "react";

const Navbar = () => {
  return (
    <div className="navbar-container">
      {" "}
      {/* Wrap the navbar content inside a container div */}
      <div className="navbar">
        <div className="logo">Your Own Legal Assistant</div>
      </div>
    </div>
  );
};

export default Navbar;
